;(function($, window, document){
    window.ProductsListingSideScrolling = Me.view.extend({
        options: {
            productCount: 0,
            totalWidth: 0
        },

        initialize: function() {
            _.bindAll(this, 'calculateScrollingWidth', 'scrollLeft', 'scrollRight', 'scrollHandler', 'breakpointChanged');

            this.addEvents();

            var products = [];
            this.$('.product').each(function(index,value) {
                var product = {};

                product.id = $(value).attr('data-sku');
                product.name = $(value).find('.product-name').html() + ' - ' + $(value).find('.product-description').html();

                if ($(value).attr('data-sku').indexOf('C1') != -1) {
                    product.brand = 'Radix';
                } else if ($(value).attr('data-sku').indexOf('C2') != -1) {
                    product.brand = 'Volitare';
                } else if ($(value).attr('data-sku').indexOf('C3') != -1){
                    product.brand = 'Braccas'; 
                }else{
                    if(locale == 'fr'){
                        product.brand = 'Autre';
                    }else {
                        product.brand = 'Other';
                    }
                }

                product.list_name = window.location.href;
                product.variant = $(value).attr('data-finish');
                product.quantity = $(value).find('.quantity').attr('data-value') ? $(value).find('.quantity').attr('data-value') : 1;
                products.push(product)
            });


            if(products.length != 0){
                gtag('event', 'view_item_list', {"items": products});
            }

            this.options.productCount = this.$('.product').length;

            this.calculateScrollingWidth();
        },
        addEvents: function() {
            this.$('.arrows-controls .arrow-button.left').on('click', this.scrollLeft);
            this.$('.arrows-controls .arrow-button.right').on('click', this.scrollRight);
            this.$('.content').on('scroll', this.scrollHandler);
            Me.dispatch.subscribe('breakpointChanged', this.breakpointChanged);
        },
        breakpointChanged: function(e, params){
            this.calculateScrollingWidth();
            this.scrollHandler();
        },
        calculateScrollingWidth: function(){
            var view = this;
            this.options.totalWidth = 0;

            this.$('.product-wrapper .product').each(function(index,value){
                view.options.totalWidth += parseInt($(value).outerWidth(true));
            });   

            this.$('.product-wrapper').css('width', this.options.totalWidth);
                
            if(this.options.totalWidth <= this.$('.content').outerWidth(true)){
                this.$('.arrows-controls').addClass('hide');
                this.$('.product-wrapper').css('width', 'auto');
            } else {
                this.$('.arrows-controls').removeClass('hide');
            }

        },
        scrollLeft: function(e){
            this.$('.arrows-controls .arrow-button.right').removeClass('disabled');
            this.$('.content').animate({scrollLeft: this.$('.content').scrollLeft() - 128}, 400);
        },
        scrollRight: function(e){
            this.$('.arrows-controls .arrow-button.left').removeClass('disabled');
            this.$('.content').animate({scrollLeft: this.$('.content').scrollLeft() + 128}, 400);
        },
        scrollHandler: function(){
            this.$('.arrows-controls .arrow-button.left').removeClass('disabled');
            this.$('.arrows-controls .arrow-button.right').removeClass('disabled');

            //update states on the arrows whenever we reach end of a scroll direction
            if(this.$('.content').scrollLeft() >= this.options.totalWidth - this.$('.content').outerWidth(true)){
                this.$('.arrows-controls .arrow-button.right').addClass('disabled');
            }else if(this.$('.content').scrollLeft() <= 0){
                this.$('.arrows-controls .arrow-button.left').addClass('disabled');
            }
        },
        scrollToNextElement: function(pDirection){
            var scroll = 0;

            //round up to the next or previous element by snapping to the element.
            if(pDirection == 'left'){
                //remainder after division of our scrollLeft by the width of one element(.product)
                scroll = this.$('.content').scrollLeft() % parseInt(this.$('.product').outerWidth(true));
            }else{
                //remainder after division of our scrollLeft by the width of one element(.product) substracted to the width of an element.
                scroll = parseInt(this.$('.product').outerWidth(true)) - this.$('.content').scrollLeft() % parseInt(this.$('.product').outerWidth(true));
            }

            //whenever we get a scroll of 0 means we are exactly at the position of an element, so we scroll a whole element left or right
            if(scroll == 0){
                scroll = parseInt(this.$('.product').outerWidth(true));
            }

            return scroll;
        }
    });
}(jQuery, window, document));
